import React from "react";
import PricingCard from "./components/shared/PricingCard";
import RateItem from "./components/shared/RateItem";
import { RegularCardIcons, AmexCardIcon } from "./constants/icons";
import useSalesFormStore from "../../../../../../../../stores/sales-form";
import getPricingDataById from "./utils/get-pricing-data-by-id";
import formatPercentage from "./utils/format-percentage";
import formatCurrency from "./utils/format-currency";
import styles from "./style.module.scss";
import { isNumeric } from "../../../../../../../../../helpers/dataHelpers";

const KurvPricing = () => {
  const applicationData = useSalesFormStore((state) => state.applicationData);
  return (
    <div className={styles.icPlus}>
      <div className={styles.rateCards}>
        <PricingCard title="Kurv Swiped" icons={<RegularCardIcons />}>
          <div className={styles.ratesList}>
            <RateItem
              label="Kurv Swiped Rate"
              value={formatPercentage(
                getPricingDataById(58, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Kurv Swiped Txn Fee"
              value={formatCurrency(
                getPricingDataById(58, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>

        <PricingCard title="Kurv Keyed" icons={<RegularCardIcons />}>
          <div className={styles.ratesList}>
            <RateItem
              label="Kurv Keyed Rate"
              value={formatPercentage(
                getPricingDataById(59, applicationData?.prices)?.percent,
              )}
            />
            <RateItem
              label="Kurv Keyed Txn Fee"
              value={formatCurrency(
                getPricingDataById(59, applicationData?.prices)?.dollars,
              )}
            />
          </div>
        </PricingCard>


        {
          (isNumeric(getPricingDataById(60, applicationData?.prices)?.percent) &&
            getPricingDataById(60, applicationData?.prices)?.percent > 0 &&
            isNumeric(getPricingDataById(60, applicationData?.prices)?.dollars) &&
            getPricingDataById(60, applicationData?.prices)?.dollars > 0
          )
          && (
            <PricingCard title="Rate Fees AMEX" icons={<AmexCardIcon />}>
              <div className={styles.ratesList}>
                <RateItem
                  label="Amex Rate"
                  value={formatPercentage(
                    getPricingDataById(60, applicationData?.prices)?.percent,
                  )}
                />
                <RateItem
                  label="Amex Txn Fee"
                  value={formatCurrency(
                    getPricingDataById(60, applicationData?.prices)?.dollars,
                  )}
                />
              </div>
            </PricingCard>
          )
        }

      </div>
    </div>
  );
};

export default KurvPricing;
